<link-account-page>
  <div if="{locale}" class="container">
    <div class="verification-card">
      <div class="brand-header">
        <img src="./Lark.png" alt="MetaLark.ai" class="brand-logo" />
        <h1 class="brand-title">{locale?.t('linkaccount_title')}</h1>
        <p class="brand-tagline">{locale?.t('linkaccount_tagline')}</p>
      </div>

      <div if={state.loading} class="loading-state">
        <div class="spinner"></div>
        <h2>{locale?.t('linkaccount_verifying_title')}</h2>
        <p>{locale?.t('linkaccount_verifying_message')}</p>
      </div>

      <div if={state.emailVerified && !state.oauthVerified && !state.error} class="instruction-state">
        <div class="info-icon">ℹ️</div>
        <h2>{locale?.t('linkaccount_emailverified_title')}</h2>
        <p>{locale?.t('linkaccount_emailverified_message')}</p>
        <div class="instruction-box">
          <h3>{locale?.t('linkaccount_finalstep_title', { providerName: state.providerName })}</h3>
          <p>{locale?.t('linkaccount_finalstep_message', { providerName: state.providerName })}</p>
          <ol class="instruction-list">
            <li>{locale?.t('linkaccount_step1', { providerName: state.providerName })}</li>
            <li>{locale?.t('linkaccount_step2', { providerName: state.providerName })}</li>
            <li>{locale?.t('linkaccount_step3')}</li>
          </ol>
        </div>
        <div class="action-buttons">
          <a href="#/login" class="btn btn-primary">
            {locale?.t('linkaccount_continuetosignin')}
          </a>
          <a href="#/settings" class="btn btn-secondary">
            {locale?.t('linkaccount_gotosettings')}
          </a>
        </div>
      </div>

      <div if={state.success && state.linked} class="success-state">
        <div class="success-icon">✓</div>
        <h2>{locale?.t('linkaccount_success_title')}</h2>
        <p>{locale?.t('linkaccount_success_message', { providerName: state.providerName })}</p>
        <div class="success-info">
          <p><strong>{locale?.t('linkaccount_success_signinusing')}</strong></p>
          <ul class="sign-in-methods">
            <li>✓ {locale?.t('linkaccount_success_emailpassword')}</li>
            <li>✓ {locale?.t('linkaccount_success_provider', { providerName: state.providerName })}</li>
          </ul>
        </div>
        <div class="success-actions">
          <a href="#/login" class="btn btn-primary">{locale?.t('linkaccount_gotologin')}</a>
          <a href="#/settings" class="btn btn-secondary">{locale?.t('linkaccount_gotosettings')}</a>
        </div>
      </div>

      <div if={state.error} class="error-state">
        <div class="error-icon">✗</div>
        <h2>{locale?.t('linkaccount_failed_title')}</h2>
        <p class="error-message">{state.message}</p>
        <div class="error-actions">
          <a href="#/login" class="btn btn-secondary">{locale?.t('linkaccount_returntologin')}</a>
          <a href="#/settings" class="btn btn-text">{locale?.t('linkaccount_gotosettings')}</a>
        </div>
      </div>
    </div>
  </div>

  <style>
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 20px;
      border-radius: 20px;
    }

    .verification-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      padding: 40px;
      max-width: 550px;
      width: 100%;
      text-align: center;
    }

    .brand-header {
      margin-bottom: 32px;
      padding-bottom: 24px;
      border-bottom: 1px solid #e5e7eb;
    }

    .brand-logo {
      height: 48px;
      width: auto;
      margin: 0 auto 16px;
      display: block;
    }

    .brand-title {
      color: #1f2937;
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 8px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .brand-tagline {
      color: #6b7280;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      letter-spacing: 0.5px;
    }

    .loading-state,
    .success-state,
    .instruction-state,
    .error-state {
      animation: fadeIn 0.3s ease-in;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #667eea;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
      margin: 0 auto 20px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .success-icon,
    .error-icon,
    .info-icon {
      font-size: 64px;
      margin-bottom: 20px;
    }

    .success-icon {
      color: #10b981;
    }

    .error-icon {
      color: #ef4444;
    }

    .info-icon {
      color: #3b82f6;
    }

    h2 {
      color: #1f2937;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
    }

    h3 {
      color: #1f2937;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 12px;
    }

    p {
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    .error-message {
      color: #dc2626;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .instruction-box {
      background: #eff6ff;
      padding: 24px;
      border-radius: 8px;
      border-left: 4px solid #3b82f6;
      margin: 24px 0;
      text-align: left;
    }

    .instruction-list {
      text-align: left;
      padding-left: 24px;
      margin: 16px 0;
      line-height: 1.8;
    }

    .instruction-list li {
      margin-bottom: 8px;
      color: #374151;
    }

    .success-info {
      background: #d1fae5;
      padding: 20px;
      border-radius: 8px;
      border-left: 4px solid #10b981;
      margin: 24px 0;
      text-align: left;
    }

    .sign-in-methods {
      list-style: none;
      padding: 0;
      margin: 12px 0 0 0;
    }

    .sign-in-methods li {
      padding: 8px 0;
      color: #065f46;
      font-weight: 500;
    }

    .action-buttons {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }

    @media (min-width: 640px) {
      .action-buttons {
        flex-direction: row;
        justify-content: center;
      }
    }

    .btn {
      padding: 12px 24px;
      border-radius: 8px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
      font-size: 16px;
      text-decoration: none;
      display: inline-block;
      margin: 6px;
    }

    .btn-primary {
      background: #667eea;
      color: white;
    }

    .btn-primary:hover {
      background: #5568d3;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .btn-secondary {
      background: #f3f4f6;
      color: #374151;
    }

    .btn-secondary:hover {
      background: #e5e7eb;
    }

    .btn-text {
      background: transparent;
      color: #4338ca;
    }

    .btn-text:hover {
      background: #f3f4f6;
    }

    .success-actions,
    .error-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }

    @media (min-width: 640px) {
      .success-actions,
      .error-actions {
        flex-direction: row;
        justify-content: center;
      }
    }
  </style>

  <script>
    import { getApi } from '../services/service-loader'

    export default {
      state: {
        loading: true,
        success: false,
        error: false,
        message: '',
        emailVerified: false,
        oauthVerified: false,
        linked: false,
        providerName: 'OAuth provider',
        token: ''
      },

      async onMounted() {
        // Get token from query params
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
        const token = urlParams.get('token')

        if (!token) {
          this.update({
            loading: false,
            error: true,
            message: this.locale.t('linkaccount_error_notoken')
          })
          return
        }

        this.update({ token })

        // Verify the linking token (email step)
        await this.verifyEmailStep(token)
      },

      async verifyEmailStep(token) {
        try {
          const api = await getApi()
          const response = await api.post('/auth/account-linking/verify-email', { token })

          if (response.data.success) {
            const providerName = this.formatProviderName(response.data.oauthProvider)
            
            if (response.data.requiresOAuthReauth) {
              // Email verified, need OAuth reauth
              this.update({
                loading: false,
                success: true,
                emailVerified: true,
                oauthVerified: false,
                linked: false,
                error: false,
                providerName,
                message: this.locale.t('linkaccount_emailverified_message')
              })
            } else {
              // Both steps complete, account linked
              this.update({
                loading: false,
                success: true,
                emailVerified: true,
                oauthVerified: true,
                linked: true,
                error: false,
                providerName,
                message: this.locale.t('linkaccount_success_message', { providerName })
              })
            }
          } else {
            this.update({
              loading: false,
              error: true,
              message: response.data.message || this.locale.t('linkaccount_error_verification')
            })
          }
        } catch (error) {
          console.error('Account linking verification error:', error)
          this.update({
            loading: false,
            error: true,
            message: error.response?.data?.message || this.locale.t('linkaccount_error_generic')
          })
        }
      },

      formatProviderName(provider) {
        const names = {
          google: 'Google',
          microsoft: 'Microsoft',
          github: 'GitHub',
          okta: 'Okta',
          azure_ad: 'Azure AD'
        }
        return names[provider] || provider
      }
    }
  </script>
</link-account-page>